(() => {
  // Add to cart in view on first load, at every screen size (Mo, 2026-10-30): when the page's own button is off screen
  // and neither the phone buy panel nor the theme's sticky bar shows, a slim bar at the bottom holds name, price and the button.
  const start = () => {
    const product = document.querySelector('.wt-product');
    const atc = product && product.querySelector('.main-product__buy-buttons--container .js-add-to-cart, form[action*="/cart/add"] [name="add"]');
    if (!atc) return;
    const form = atc.closest('form');
    const title = product.querySelector('.wt-product__name');

    const bar = document.createElement('div');
    bar.className = 'vc-atc-fold';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML = '<div class="vc-atc-fold__inner"><div class="vc-atc-fold__info"><span class="vc-atc-fold__name"></span><span class="vc-atc-fold__price"></span></div><button type="button" class="vc-atc-fold__atc wt-button wt-button--primary"></button></div>';
    document.body.append(bar);
    const name = bar.querySelector('.vc-atc-fold__name');
    const priceBox = bar.querySelector('.vc-atc-fold__price');
    const button = bar.querySelector('.vc-atc-fold__atc');
    name.textContent = title ? title.textContent.trim() : '';

    // Sold-out pick: vc-soldout-notify.js hides Add to cart and shows Restock Rocket's button, so the bar copies that.
    const notify = () => (form && form.classList.contains('vc-oos-one') ? form.querySelector('.restock-rocket-button') : null);
    const priceText = () => {
      const price = product.querySelector('.wt-product__price .price');
      if (!price) return '';
      const onSale = price.querySelector('.price__sale.visible');
      return ((onSale ? onSale.querySelector('.price-item--sale') : price.querySelector('.price__regular .price-item--regular'))?.textContent || '').trim();
    };
    const fullyShown = (el) => {
      const box = el.getBoundingClientRect();
      return box.height > 0 && box.top >= 0 && box.bottom <= window.innerHeight;
    };
    const otherBarShown = () => !!document.querySelector('.vc-buy-panel.is-shown, #vc-sticky-bar.visible');

    const show = () => {
      const n = notify();
      if (n) {
        if (button.innerHTML !== n.innerHTML) button.innerHTML = n.innerHTML;
        button.classList.add('vc-oos-btn');
        button.disabled = false;
      } else {
        const label = atc.textContent.trim() || 'Add to cart';
        if (button.classList.contains('vc-oos-btn') || button.textContent !== label) button.textContent = label;
        button.classList.remove('vc-oos-btn');
        button.disabled = atc.disabled;
      }
      const price = priceText();
      if (priceBox.textContent !== price) priceBox.textContent = price;
      const on = !fullyShown(n || atc) && !otherBarShown();
      bar.classList.toggle('is-shown', on);
      document.body.classList.toggle('vc-atc-fold-on', on);
    };

    button.addEventListener('click', () => {
      const n = notify();
      if (!n) {
        if (!atc.disabled) atc.click();
        return;
      }
      // A scripted click on the app's button doesn't open its form; its own openModal does (as in vc-phone-colour-picker.js).
      const rr = window._RestockRocket;
      const variant = form.querySelector('input[name="id"]');
      const handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
      if (rr && typeof rr.openModal === 'function' && variant && handle) {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(`${root}products/${handle}.js`)
          .then((r) => r.json())
          .then((p) => rr.openModal(p, Number(variant.value)))
          .catch(() => n.scrollIntoView({ block: 'center', behavior: 'smooth' }));
      } else {
        n.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });

    let queued = false;
    const queueShow = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; show(); });
    };
    window.addEventListener('scroll', queueShow, { passive: true });
    window.addEventListener('resize', queueShow);
    window.addEventListener('load', show);
    // The buy panel and the sticky bar decide in their own scripts, after this one starts.
    [0, 300, 1000, 2500].forEach((delay) => setTimeout(show, delay));
    new MutationObserver(queueShow).observe(product, { attributes: true, childList: true, subtree: true, characterData: true });
    new MutationObserver(queueShow).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
